import React, { Component} from 'react';
import { BrowserRouter as Router} from "react-router-dom";
// import {carWahshesContext, servicesContext} from './context';


import './media/css/normalize.css';
// import BackendApi from './BackendApi';
import ScrollToTop from './components/ScrollToTop';
import RoutGroup from './components/RoutGroup';


class App extends Component {

  // constructor(props){
	// 	super(props);

	// 	this.state = {
  //     carwashes: [],
  //     services: [],
  //   };
	// }

	// componentDidMount(){
	// 	BackendApi.iblockInfo(1).then((result) => {
	// 		this.setState({
	// 			carwashes: Array.isArray(result.data.result) ? result.data.result:[],
  //     });
  //   })
  // }
  
  
  
  render(){
    
    return (
      <div style={{backgroundColor: '#EEEEEE', minHeight:'100vh'}}>
        <Router>
          <ScrollToTop />
          <RoutGroup />
        </Router>
      </div>    
    );
  }
}

export default App;